function Icon() {
  return (
    <svg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='60' height='60' rx='8' fill='#E6F0FF' />
      <path
        opacity='0.4'
        d='M39 25.5V30.6975C39 30.9375 38.8097 31.1235 38.5712 31.137C34.4882 31.3605 31.125 34.749 31.125 38.88C31.125 40.317 31.521 41.6715 32.217 42.8295C32.394 43.125 32.1585 43.5 31.8135 43.5H21C18 43.5 16.5 42 16.5 39V21C16.5 18 18 16.5 21 16.5H30V21C30 23.4855 32.0145 25.5 34.5 25.5H39Z'
        fill='#2A64F6'
      />
      <path d='M34.5 25.5H39L30 16.5V21C30 24 31.5 25.5 34.5 25.5Z' fill='#2A64F6' />
      <path
        d='M33 31.125H22.5C21.879 31.125 21.375 30.621 21.375 30C21.375 29.379 21.879 28.875 22.5 28.875H33C33.621 28.875 34.125 29.379 34.125 30C34.125 30.621 33.621 31.125 33 31.125ZM29.625 36C29.625 35.379 29.121 34.875 28.5 34.875H22.5C21.879 34.875 21.375 35.379 21.375 36C21.375 36.621 21.879 37.125 22.5 37.125H28.5C29.121 37.125 29.625 36.621 29.625 36Z'
        fill='#2A64F6'
      />
      <path
        d='M45.795 44.205L43.47 41.88C44.037 41.0145 44.3745 39.9855 44.3745 38.8755C44.3745 35.8425 41.907 33.375 38.8755 33.375C35.8425 33.375 33.375 35.8425 33.375 38.8755C33.375 41.9085 35.8425 44.376 38.8755 44.376C39.9855 44.376 41.0144 44.04 41.8799 43.473L44.205 45.7965C44.424 46.0155 44.712 46.1265 45 46.1265C45.288 46.1265 45.576 46.017 45.795 45.7965C46.2345 45.3555 46.2345 44.643 45.795 44.205ZM35.625 38.8755C35.625 37.083 37.083 35.625 38.8755 35.625C40.6665 35.625 42.1245 37.083 42.1245 38.8755C42.1245 40.668 40.6665 42.126 38.8755 42.126C37.083 42.1245 35.625 40.6665 35.625 38.8755Z'
        fill='#2A64F6'
      />
    </svg>
  );
}

export default Icon;
